import { useSyncExternalStore } from "react";

/**
 * True while the CSS media query matches; false on the server and where `matchMedia` is
 * missing (tests, old browsers), so the narrow layout is the safe default.
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (notify) => {
      if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
        return () => undefined;
      }
      const list = window.matchMedia(query);
      list.addEventListener("change", notify);
      return () => list.removeEventListener("change", notify);
    },
    () =>
      typeof window !== "undefined" && typeof window.matchMedia === "function"
        ? window.matchMedia(query).matches
        : false,
    () => false,
  );
}

/**
 * The case page puts the mail beside the work column (400 px) from this width, so a 1366
 * or 1440 px laptop shows the mail, the draft and the action at once. Below it the page
 * is one column: mail, then the work.
 */
export const WIDE_CASE_QUERY = "(min-width: 1280px)";
/** Narrow screens get cards instead of tables (below Tailwind `md`). */
export const NARROW_QUERY = "(max-width: 767px)";
/** A device whose main pointer is a finger: no keyboard-shortcut button. */
export const TOUCH_QUERY = "(hover: none) and (pointer: coarse)";
